export default "__VITE_ASSET__dea819c9__"